module.exports = __webpack_public_path__ + "img/shopping_cart.d83c7149.png";